export class GuidelineSourceExclusionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async excludeSource({ sourceId }) {
    return this.#http.post(`/guidelines/sources/${sourceId}/exclusion`);
  }

  async includeSource({ sourceId }) {
    return this.#http.delete(`/guidelines/sources/${sourceId}/exclusion`);
  }
}
